import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { CommunityMember } from "@circle-react/types";

import {
  computeGradientStyle,
  getAvatarFallbackColor,
} from "@/react/components/ProfileModalV4/Sidebar/colors";
import { useImageDominantColor } from "@/react/hooks/useImageDominantColor";

interface MemberGradientBackgroundProps {
  className?: string;
  member: CommunityMember;
}

/**
 * @description
 * Place this inside a parent with the className "relative"
 */
export const MemberGradientBackground = ({
  member,
  className,
}: MemberGradientBackgroundProps) => {
  const { rgba } = useImageDominantColor({
    imageUrl: member.avatar_url,
    fallbackColor: getAvatarFallbackColor(member.name ?? ""),
    enabled: Boolean(member.avatar_url),
  });

  return (
    <div
      className={classNames(
        "pointer-events-none absolute inset-3 z-0 rounded-md h-[322px]",
        className,
      )}
      style={computeGradientStyle(rgba)}
      aria-hidden="true"
      data-testid="member-card-gradient"
    />
  );
};
